/**
 * Global LIFO registry of "back" handlers used to make the Android hardware /
 * gesture back button behave like a native app: the most recently opened
 * overlay (modal, editor, detail page) intercepts the back press first.
 *
 * Components register a handler while an overlay is open (see useBackButton).
 * App.js invokes handleBackPress() from the Capacitor `backButton` listener.
 */

const stack = [];

/**
 * Register a back handler. Returns an unregister function.
 * The handler should return `true` if it consumed the back action.
 */
export function registerBackHandler(handler) {
  stack.push(handler);
  return () => {
    const index = stack.lastIndexOf(handler);
    if (index !== -1) stack.splice(index, 1);
  };
}

/**
 * Invoke the top-most handler that consumes the back press.
 * Returns true if a handler consumed it, false otherwise.
 */
export function handleBackPress() {
  for (let i = stack.length - 1; i >= 0; i -= 1) {
    try {
      if (stack[i]() === true) return true;
    } catch (_) {
      // Ignore a broken handler and fall through to the next one.
    }
  }
  return false;
}
